import { motion } from "framer-motion";
import RevealLine from "./RevealLine";
import { VENUE_WIDE_IMG, VENUE_TALL_IMG } from "@/lib/links";

const Venue = () => (
  <section data-testid="venue-section" className="relative bg-night px-5 sm:px-10 py-20 sm:py-28 overflow-hidden">
    <div className="mx-auto max-w-5xl grid lg:grid-cols-[1.2fr_1fr] gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <img
          src={VENUE_WIDE_IMG}
          alt="Royal Calcutta Turf Club grandstand at dusk with the Victoria Memorial beyond the track"
          data-testid="venue-wide-image"
          className="w-full aspect-[3/2] object-cover"
        />
        <img
          src={VENUE_TALL_IMG}
          alt="Lit colonial grandstand of the Royal Calcutta Turf Club at night"
          data-testid="venue-tall-image"
          className="absolute -bottom-8 -right-3 sm:-right-8 w-[34%] aspect-[2/3] object-cover border-[6px] border-night shadow-[0_24px_60px_rgba(0,0,0,0.6)]"
        />
      </motion.div>

      <div className="lg:order-first">
        <RevealLine inView className="eyebrow">The Venue</RevealLine>
        <h2 className="mt-5 font-display font-bold uppercase leading-[1.05] tracking-tight text-2xl sm:text-3xl lg:text-4xl text-bone">
          <RevealLine inView delay={0.1}>Royal Calcutta</RevealLine>
          <RevealLine inView delay={0.2}>Turf Club.</RevealLine>
          <RevealLine inView delay={0.3} className="text-coral">Est. 1847.</RevealLine>
        </h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-6 max-w-md text-sand text-sm sm:text-base leading-relaxed"
          data-testid="venue-copy"
        >
          Turreted colonial grandstands, iron railings and open turf on the Maidan, with the Victoria Memorial
          glowing across the track. The city's most storied ground — after dark, for one night.
        </motion.p>
      </div>
    </div>
  </section>
);

export default Venue;
